import DeviceTypeManager from './DeviceTypeManager'

export default function DeviceTypesPage() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">🔧 Типы устройств</h1>
      </div>

      <DeviceTypeManager onClose={() => {}} />
    </div>
  )
}

